/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientOverviewTopStory {
    clipId?: string;
    headline?: string;
    brief?: string;
    outletName?: string;
    outletType?: string;
    publicationDate?: string;
    brandTagName?: string;
    sentiment?: string;
    authorNames?: Array<string>;
    reach?: number;
    impact?: number;
    url?: string;
    sourceType?: string;
    industryTopics?: Array<string>;
    corporateTopics?: Array<string>;
    competitorOnly?: boolean;
}
